import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum TicketRouteNames {
  TICKET_TABLE = "TICKET_TABLE",
  TICKET_DETAIL = "TICKET_DETAIL",
  PROJECT_DETAIL = "PROJECT_DETAIL",
  PROJECT_TABLE = "PROJECT_TABLE",
  PROJECT_CUSTOM_VIEW = "PROJECT_CUSTOM_VIEW"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Ticket = { ticketId: string };
type Project = { projectId: string };
type View = { viewId: string };
type Query = { query?: Record<string, string> };

export class TicketGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = TicketGoToHelper.locations;

    return {
      TicketTable: (partnerId: string) => {
        return {
          text: $t("project.ticket.tickets").toString(),
          exact: true,
          to: locations.ticketTable({ partnerId })
        };
      },
      TicketDetail: (partnerId: string, ticketId: string) => {
        return {
          text: $t("project.ticket.ticket").toString(),
          exact: true,
          to: locations.ticketDetail({ partnerId, ticketId })
        };
      },

      ProjectTable: (partnerId: string) => {
        return {
          text: $t("project.ticket.projects").toString(),
          exact: true,
          to: locations.projectTable({ partnerId })
        };
      },

      ProjectCustomView: (partnerId: string, projectId: string, viewId?: string) => {
        return {
          text: $t("project.ticket.project").toString(),
          exact: true,
          to: locations.projectCustomView({ partnerId, projectId, viewId: viewId ?? "0" })
        };
      },

      ProjectDetail: (partnerId: string, projectId: string) => {
        return {
          text: $t("common.verbs.edit").toString(),
          exact: true,
          to: locations.projectDetail({ partnerId, projectId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    ticketTable: (d: Partner & Query) => {
      return {
        name: TicketRouteNames.TICKET_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    ticketDetail: (d: Partner & Ticket & Query) => {
      return {
        name: TicketRouteNames.TICKET_DETAIL,
        params: { partnerId: d.partnerId, ticketId: d.ticketId },
        query: d.query
      };
    },

    projectDetail: (d: Partner & Project & Query) => {
      return {
        name: TicketRouteNames.PROJECT_DETAIL,
        params: { partnerId: d.partnerId, projectId: d.projectId },
        query: d.query
      };
    },
    projectTable: (d: Partner & Query) => {
      return {
        name: TicketRouteNames.PROJECT_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    projectCustomView: (d: Partner & Project & View & Query) => {
      return {
        name: TicketRouteNames.PROJECT_CUSTOM_VIEW,
        params: { partnerId: d.partnerId, projectId: d.projectId, viewId: d.viewId },
        query: d.query
      };
    }
  };

  goToTicketTable(d: Tab & Partner) {
    this.go(TicketGoToHelper.locations.ticketTable(d), d.newTab);
  }

  goToTicketDetail(d: Tab & Partner & Ticket) {
    this.go(TicketGoToHelper.locations.ticketDetail(d), d.newTab);
  }

  goToProjectTable(d: Tab & Partner) {
    this.go(TicketGoToHelper.locations.projectTable(d), d.newTab);
  }

  goToProjectDetail(d: Tab & Partner & Project) {
    this.go(TicketGoToHelper.locations.projectDetail(d), d.newTab);
  }

  goToProjectCustomView(d: Tab & Partner & Project & View) {
    this.go(TicketGoToHelper.locations.projectCustomView(d), d.newTab);
  }
}
